/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { TeamDevelopmentEmployeeSearchRequestDto } from '../models';
// @ts-ignore
import type { TeamDevelopmentEmployeeSearchResultDto } from '../models';
// @ts-ignore
import type { TeamEmployeeSortByDto } from '../models';
/**
 * TeamDevelopmentEmployeesApi - axios parameter creator
 * @export
 */
export const TeamDevelopmentEmployeesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Paginated list of the current user\'s team employees with MDR field, plan progress and plan status computed against the active development cycle (JAIN-208). KPI counters come from a separate endpoint.
         * @summary List a manager\'s team employees by development (Twój zespół P1)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {TeamDevelopmentEmployeeSearchRequestDto} teamDevelopmentEmployeeSearchRequestDto Team development employees list filter
         * @param {SortDirectionDto} [sortOrder] 
         * @param {TeamEmployeeSortByDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeamDevelopmentEmployees: async (pageSize: number, page: number, teamDevelopmentEmployeeSearchRequestDto: TeamDevelopmentEmployeeSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: TeamEmployeeSortByDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchTeamDevelopmentEmployees', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchTeamDevelopmentEmployees', 'page', page)
            // verify required parameter 'teamDevelopmentEmployeeSearchRequestDto' is not null or undefined
            assertParamExists('searchTeamDevelopmentEmployees', 'teamDevelopmentEmployeeSearchRequestDto', teamDevelopmentEmployeeSearchRequestDto)
            const localVarPath = `/api/v2/team/development/employees/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamDevelopmentEmployeeSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamDevelopmentEmployeesApi - functional programming interface
 * @export
 */
export const TeamDevelopmentEmployeesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamDevelopmentEmployeesApiAxiosParamCreator(configuration)
    return {
        /**
         * Paginated list of the current user\'s team employees with MDR field, plan progress and plan status computed against the active development cycle (JAIN-208). KPI counters come from a separate endpoint.
         * @summary List a manager\'s team employees by development (Twój zespół P1)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {TeamDevelopmentEmployeeSearchRequestDto} teamDevelopmentEmployeeSearchRequestDto Team development employees list filter
         * @param {SortDirectionDto} [sortOrder] 
         * @param {TeamEmployeeSortByDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTeamDevelopmentEmployees(pageSize: number, page: number, teamDevelopmentEmployeeSearchRequestDto: TeamDevelopmentEmployeeSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: TeamEmployeeSortByDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDevelopmentEmployeeSearchResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTeamDevelopmentEmployees(pageSize, page, teamDevelopmentEmployeeSearchRequestDto, sortOrder, sortBy, lang, accessType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamDevelopmentEmployeesApi.searchTeamDevelopmentEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamDevelopmentEmployeesApi - factory interface
 * @export
 */
export const TeamDevelopmentEmployeesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamDevelopmentEmployeesApiFp(configuration)
    return {
        /**
         * Paginated list of the current user\'s team employees with MDR field, plan progress and plan status computed against the active development cycle (JAIN-208). KPI counters come from a separate endpoint.
         * @summary List a manager\'s team employees by development (Twój zespół P1)
         * @param {number} pageSize 
         * @param {number} page 
         * @param {TeamDevelopmentEmployeeSearchRequestDto} teamDevelopmentEmployeeSearchRequestDto Team development employees list filter
         * @param {SortDirectionDto} [sortOrder] 
         * @param {TeamEmployeeSortByDto} [sortBy] 
         * @param {LanguageDto} [lang] 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeamDevelopmentEmployees(pageSize: number, page: number, teamDevelopmentEmployeeSearchRequestDto: TeamDevelopmentEmployeeSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: TeamEmployeeSortByDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamDevelopmentEmployeeSearchResultDto> {
            return localVarFp.searchTeamDevelopmentEmployees(pageSize, page, teamDevelopmentEmployeeSearchRequestDto, sortOrder, sortBy, lang, accessType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamDevelopmentEmployeesApi - interface
 * @export
 * @interface TeamDevelopmentEmployeesApi
 */
export interface TeamDevelopmentEmployeesApiInterface {
    /**
     * Paginated list of the current user\'s team employees with MDR field, plan progress and plan status computed against the active development cycle (JAIN-208). KPI counters come from a separate endpoint.
     * @summary List a manager\'s team employees by development (Twój zespół P1)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {TeamDevelopmentEmployeeSearchRequestDto} teamDevelopmentEmployeeSearchRequestDto Team development employees list filter
     * @param {SortDirectionDto} [sortOrder] 
     * @param {TeamEmployeeSortByDto} [sortBy] 
     * @param {LanguageDto} [lang] 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamDevelopmentEmployeesApiInterface
     */
    searchTeamDevelopmentEmployees(pageSize: number, page: number, teamDevelopmentEmployeeSearchRequestDto: TeamDevelopmentEmployeeSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: TeamEmployeeSortByDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamDevelopmentEmployeeSearchResultDto>;

}

/**
 * TeamDevelopmentEmployeesApi - object-oriented interface
 * @export
 * @class TeamDevelopmentEmployeesApi
 * @extends {BaseAPI}
 */
export class TeamDevelopmentEmployeesApi extends BaseAPI implements TeamDevelopmentEmployeesApiInterface {
    /**
     * Paginated list of the current user\'s team employees with MDR field, plan progress and plan status computed against the active development cycle (JAIN-208). KPI counters come from a separate endpoint.
     * @summary List a manager\'s team employees by development (Twój zespół P1)
     * @param {number} pageSize 
     * @param {number} page 
     * @param {TeamDevelopmentEmployeeSearchRequestDto} teamDevelopmentEmployeeSearchRequestDto Team development employees list filter
     * @param {SortDirectionDto} [sortOrder] 
     * @param {TeamEmployeeSortByDto} [sortBy] 
     * @param {LanguageDto} [lang] 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamDevelopmentEmployeesApi
     */
    public searchTeamDevelopmentEmployees(pageSize: number, page: number, teamDevelopmentEmployeeSearchRequestDto: TeamDevelopmentEmployeeSearchRequestDto, sortOrder?: SortDirectionDto, sortBy?: TeamEmployeeSortByDto, lang?: LanguageDto, accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig) {
        return TeamDevelopmentEmployeesApiFp(this.configuration).searchTeamDevelopmentEmployees(pageSize, page, teamDevelopmentEmployeeSearchRequestDto, sortOrder, sortBy, lang, accessType, options).then((request) => request(this.axios, this.basePath));
    }
}

